// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-page-body {
  display: flex;
  gap: var(--_120px_6_padding);
  padding: var(--_120px_6_padding);
  font-family: var(--paragraphFont);
  position: relative;
  min-height: 100%;
  flex-grow: 1;
  box-sizing: border-box;
}

.legal-sidebar {
  height: calc(100vh - 2 * var(--_120px_6_paddingHorizontal) - var(--menuBarHeight));
  top: calc(var(--menuBarHeight) + var(--_120px_6_paddingHorizontal));
  box-sizing: border-box;
}
.legal-sidebar-inner {
  width: max-content;
  max-width: 300px;
}
@media screen and (max-width: 768px) {
  .legal-sidebar {
    display: none !important;
  }
}

.legal-page-body ul {
    list-style-type: square;
    font-family: var(--paragraphFont);
}
.legal-page-body ul > li > ul {
    list-style-type: circle;
    font-family: var(--paragraphFont);
}
.legal-page-body ul > li > ul > li > ul {
    list-style-type: square;
    font-family: var(--paragraphFont);
}
.legal-page-body ol li {
    font-family: var(--paragraphFont);
}

[data-custom-class='body'], [data-custom-class='body'] * {
  background: transparent !important;
  font-family: var(--paragraphFont);
}
[data-custom-class='title'], [data-custom-class='title'] *, rulestitle {
  font-family: var(--displayFont);
  font-size: 50px !important;
  color: #000 !important;
}
[data-custom-class='subtitle'], [data-custom-class='subtitle'] *, rulessubtitle {
  font-family: var(--displayFont);
  color: #595959 !important;
  font-size: 20px !important;
}
[data-custom-class='heading_1'], [data-custom-class='heading_1'] *, .legal-page-body h1 {
  font-family: var(--displayFont);
  font-size: 24px !important;
  color: #000 !important;
}
[data-custom-class='heading_2'], [data-custom-class='heading_2'] *, .legal-page-body h2 {
  font-family: var(--displayFont);
  font-size: 18px !important;
  color: #000000 !important;
}

[data-custom-class='body_text'], [data-custom-class='body_text'] *, .legal-page-body p {
  color: #595959 !important;
  font-size: 16px !important;
  font-weight: 500;
  font-family: var(--paragraphFont);
}
[data-custom-class='link'], [data-custom-class='link'] * {
  color: var(--linkColor) !important;
  font-size: 16px !important;
  font-family: var(--paragraphFont);
  word-break: break-word !important;
  text-decoration: none;
}
[data-custom-class='link']:hover, [data-custom-class='link'] *:hover {
  font-family: var(--paragraphFont);
  text-decoration: underline !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/about/Legal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kFAAkF;EAClF,mEAAmE;EACnE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,iCAAiC;EACjC,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,iCAAiC;EACjC,qCAAqC;AACvC","sourcesContent":[".legal-page-body {\n  display: flex;\n  gap: var(--_120px_6_padding);\n  padding: var(--_120px_6_padding);\n  font-family: var(--paragraphFont);\n  position: relative;\n  min-height: 100%;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n.legal-sidebar {\n  height: calc(100vh - 2 * var(--_120px_6_paddingHorizontal) - var(--menuBarHeight));\n  top: calc(var(--menuBarHeight) + var(--_120px_6_paddingHorizontal));\n  box-sizing: border-box;\n}\n.legal-sidebar-inner {\n  width: max-content;\n  max-width: 300px;\n}\n@media screen and (max-width: 768px) {\n  .legal-sidebar {\n    display: none !important;\n  }\n}\n\n.legal-page-body ul {\n    list-style-type: square;\n    font-family: var(--paragraphFont);\n}\n.legal-page-body ul > li > ul {\n    list-style-type: circle;\n    font-family: var(--paragraphFont);\n}\n.legal-page-body ul > li > ul > li > ul {\n    list-style-type: square;\n    font-family: var(--paragraphFont);\n}\n.legal-page-body ol li {\n    font-family: var(--paragraphFont);\n}\n\n[data-custom-class='body'], [data-custom-class='body'] * {\n  background: transparent !important;\n  font-family: var(--paragraphFont);\n}\n[data-custom-class='title'], [data-custom-class='title'] *, rulestitle {\n  font-family: var(--displayFont);\n  font-size: 50px !important;\n  color: #000 !important;\n}\n[data-custom-class='subtitle'], [data-custom-class='subtitle'] *, rulessubtitle {\n  font-family: var(--displayFont);\n  color: #595959 !important;\n  font-size: 20px !important;\n}\n[data-custom-class='heading_1'], [data-custom-class='heading_1'] *, .legal-page-body h1 {\n  font-family: var(--displayFont);\n  font-size: 24px !important;\n  color: #000 !important;\n}\n[data-custom-class='heading_2'], [data-custom-class='heading_2'] *, .legal-page-body h2 {\n  font-family: var(--displayFont);\n  font-size: 18px !important;\n  color: #000000 !important;\n}\n\n[data-custom-class='body_text'], [data-custom-class='body_text'] *, .legal-page-body p {\n  color: #595959 !important;\n  font-size: 16px !important;\n  font-weight: 500;\n  font-family: var(--paragraphFont);\n}\n[data-custom-class='link'], [data-custom-class='link'] * {\n  color: var(--linkColor) !important;\n  font-size: 16px !important;\n  font-family: var(--paragraphFont);\n  word-break: break-word !important;\n  text-decoration: none;\n}\n[data-custom-class='link']:hover, [data-custom-class='link'] *:hover {\n  font-family: var(--paragraphFont);\n  text-decoration: underline !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
